/* ============================================================
   KIAH SKIN ALCHEMY — theme.js
   Vanilla JS, no dependencies. Deferred.
   ============================================================ */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.fade-up');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sticky / transparent header ---------- */
  function initHeader() {
    var announcement = document.querySelector('.announcement');
    function setAnnHeight() {
      var h = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setAnnHeight();
    window.addEventListener('resize', setAnnHeight);

    var header = document.querySelector('.header--transparent');
    if (!header) return;
    var threshold = announcement ? announcement.offsetHeight : 40;
    function onScroll() {
      if (window.scrollY > threshold) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    var close = nav.querySelector('[data-mobile-close]');
    function open() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function shut() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', shut); });
  }

  /* ---------- Accordions on home/product handled natively via <details> ---------- */

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        var alt = t.getAttribute('data-alt') || '';
        var w = t.getAttribute('data-w');
        var h = t.getAttribute('data-h');
        if (main && src) {
          if (w && h) { main.setAttribute('width', w); main.setAttribute('height', h); }
          main.src = src;
          main.alt = alt;
        }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariants() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var data = document.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent || '[]');
    var select = form.querySelector('[data-variant-select]');
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-btn]');
    if (!select) return;
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addBtn.getAttribute('data-add-label') : 'Sold out';
      }
    });
  }

  /* ---------- Money format ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return (window.KiahMoneyPrefix || '$') + amount + (window.KiahMoneySuffix || ' AUD');
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: null, overlay: null, items: null, count: null, subtotal: null, foot: null, progress: null,
    threshold: 0,
    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-drawer-overlay]');
      this.items = document.querySelector('[data-cart-items]');
      this.count = document.querySelectorAll('[data-cart-count]');
      this.subtotal = document.querySelector('[data-cart-subtotal]');
      this.foot = document.querySelector('[data-cart-foot]');
      this.progress = document.querySelector('[data-cart-progress]');
      this.threshold = parseInt((this.progress && this.progress.getAttribute('data-threshold')) || '0', 10);
      var self = this;

      document.querySelectorAll('[data-cart-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); self.open(); self.refresh(); });
      });
      document.querySelectorAll('[data-cart-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });

      document.addEventListener('click', function (e) {
        var addForm = e.target.closest('[data-add-form]');
        if (addForm && e.target.closest('[data-add-btn]')) {
          e.preventDefault();
          self.add(addForm);
        }
        var quick = e.target.closest('[data-quick-add]');
        if (quick) {
          e.preventDefault();
          self.addVariant(quick.getAttribute('data-variant-id'), 1);
        }
      });
    },
    open: function () {
      if (this.drawer) this.drawer.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (this.drawer) this.drawer.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    add: function (form) {
      var fd = new FormData(form);
      var self = this;
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { self.open(); self.refresh(); })
        .catch(function () { form.submit(); });
    },
    addVariant: function (id, qty) {
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function () { self.open(); self.refresh(); })
        .catch(function () { window.location.href = '/cart'; });
    },
    change: function (key, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function () { self.refresh(); });
    },
    refresh: function () {
      var self = this;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); });
    },
    render: function (cart) {
      var self = this;
      this.count.forEach(function (c) { c.textContent = cart.item_count; c.style.display = cart.item_count ? '' : 'none'; });
      if (!this.items) return;
      if (!cart.item_count) {
        this.items.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is feeling light.</p><a class="link-underline" href="/collections/all">Shop the range</a></div>';
        if (this.foot) this.foot.style.display = 'none';
        if (this.progress) this.progress.style.display = 'none';
        return;
      }
      if (this.foot) this.foot.style.display = '';
      var html = '';
      cart.items.forEach(function (it) {
        html += '<div class="cart-line">' +
          '<div class="cart-line__media"><img src="' + (it.image ? it.image.replace(/(\.[^.]+)$/, '_120x$1') : '') + '" alt="' + it.product_title + '" width="64" height="64"></div>' +
          '<div><div class="cart-line__title">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-line__variant">' + it.variant_title + '</div>' : '') +
          '<div class="cart-line__qty"><button data-dec="' + it.key + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-inc="' + it.key + '" aria-label="Increase">+</button></div>' +
          '<button class="cart-line__remove" data-remove="' + it.key + '">Remove</button></div>' +
          '<div class="cart-line__price">' + formatMoney(it.final_line_price) + '</div>' +
          '</div>';
      });
      this.items.innerHTML = html;
      if (this.subtotal) this.subtotal.textContent = formatMoney(cart.total_price);

      if (this.progress && this.threshold > 0) {
        this.progress.style.display = '';
        var fill = this.progress.querySelector('.cart-progress-fill');
        var label = this.progress.querySelector('[data-progress-label]');
        var pct = Math.min(100, (cart.total_price / this.threshold) * 100);
        if (fill) fill.style.width = pct + '%';
        if (label) {
          var remaining = this.threshold - cart.total_price;
          label.textContent = remaining > 0
            ? 'You are ' + formatMoney(remaining) + ' away from free shipping'
            : 'You have unlocked free shipping ✦';
        }
      }

      this.items.querySelectorAll('[data-inc]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-inc');
          var it = cart.items.find(function (x) { return x.key === key; });
          self.change(key, it.quantity + 1);
        });
      });
      this.items.querySelectorAll('[data-dec]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-dec');
          var it = cart.items.find(function (x) { return x.key === key; });
          self.change(key, Math.max(0, it.quantity - 1));
        });
      });
      this.items.querySelectorAll('[data-remove]').forEach(function (b) {
        b.addEventListener('click', function () { self.change(b.getAttribute('data-remove'), 0); });
      });
    }
  };

  /* ---------- Qty selector on product page ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelector('[data-qty-dec]').addEventListener('click', function () {
        input.value = Math.max(1, parseInt(input.value, 10) - 1);
      });
      wrap.querySelector('[data-qty-inc]').addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeader();
    initMobileNav();
    initGallery();
    initVariants();
    initQty();
    Cart.init();
    Cart.refresh();
  });
})();
